import * as React from "react";
import { useContext, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { TabStripSelectEventArguments } from "@progress/kendo-react-layout";
import { IconWrapper } from "./IconWrapper";
import { Flex } from "./Flex";
import { ToggleTabStrip } from "./ToggleTabStrip";
import { Sticky } from "./Sticky";
import { InboundTab } from "./InboundTab/InboundTab";
import ReturnTab from "./ReturnTab/ReturnTab";
import { EditProjectContext } from "../EditProjectContext";
import { isProjectReadOnly } from "../IsProjectReadOnly";
import { AddSpdrsAndPdsrs } from "./InboundTab/AddSpdrPdsrs";
import { ReadOnlyProps } from "../ReadOnlyProps";

export const InboundReturnTabControl = ({ isReadOnly }: ReadOnlyProps) => {
  const [visible, setVisible] = useState<boolean>(true);
  const [selected, setSelected] = React.useState<number>(0);

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  };

  const { project } = useContext(EditProjectContext);
  const isInboundAndReturnTabReadOnly = isProjectReadOnly(project) || isReadOnly;

  return (
    <Sticky style={{ zIndex: 2 }}>
      {visible && <AddSpdrsAndPdsrs disabled={isReadOnly} />}

      <Flex>
        <ToggleTabStrip visible={visible} selected={selected} onSelect={handleSelect}>
          {[
            ...InboundTab({ isReadOnly: isInboundAndReturnTabReadOnly }),
            ...ReturnTab({ isReadOnly: isInboundAndReturnTabReadOnly }),
          ]}
        </ToggleTabStrip>
        <IconWrapper onClick={() => setVisible(!visible)} $visible={visible}>
          {visible ? (
            <FontAwesomeIcon icon={faChevronLeft} />
          ) : (
            <FontAwesomeIcon icon={faChevronRight} />
          )}
        </IconWrapper>
      </Flex>
    </Sticky>
  );
};
